export default {
  data: () => ({
    rules: {
      // Valida se o campo está preenchido
      required: (value) => {
        return !!value || "Preencha esse campo";
      },
      // Valida se o campo tem um número mínimo de caracteres
      minLength: (min) => (value) =>
        (value && value.length >= min) ||
        `Deve ter pelo menos ${min} caracteres`,
      // Valida se o campo tem um número máximo de caracteres
      maxLength: (max) => (value) =>
        (value && value.length <= max) ||
        `Deve ter no máximo ${max} caracteres`,
      // Valida se o email é válido
      email: (value) =>
        /.+@.+\..+/.test(value) || 'E-mail deve ser válido',
      // Valida se o valor é um número
      isNumber: (value) =>
        !isNaN(parseFloat(value)) || 'Deve ser um número válido',
      // Valida se o número é maior que 0
      validNumber: (value) => {
        return value > 0 || "Inválido";
      },
      // Valida se o valor é igual a outro campo (ex.: confirmação de senha)
      isEqual: (fieldToCompare) => (value) =>
        value === fieldToCompare || 'Os valores não coincidem',
      // Valida se um array está vazio
      emptyTable: (fieldToCheck) => {
        return Array.isArray(fieldToCheck) && fieldToCheck.length > 0 || 'É necessário adicionar um item';
      },
      validMoney: (value) => parseFloat(String(value).replace(/[R$.\s]/g, "").replace(",", ".")) > 0 || 'Inválido',
    },
  }),
};